import { ReferenceLink } from './ReferenceLink';

export class Remediation {
  constructor(
    private readonly remediation: string,
    private readonly triage: string | null,
    private readonly advice: string | null,
    private readonly link: ReferenceLink | null
  ) {}

  getRemediation() {
    return this.remediation;
  }

  getTriage() {
    return this.triage;
  }

  getAdvice() {
    return this.advice;
  }

  getLink() {
    return this.link;
  }
}
